import React from 'react';
import PractitionerCard from './PractitionerCard';
import { getSpecialtyCategory } from '../../utils/categories';

export default function PractitionersColumn({
  dataLoading,
  activePractitioners,
  activeServices,
  categories,
  specialties,
  selectedCategory,
  selectedPractitioner,
  setSelectedPractitioner,
  setSelectedCategory,
  setSelectedService,
  setMainBgColor,
  activePracTab,
  setActivePracTab,
  primaryOfferedServices,
  addonOfferedServices,
  adminMode,
  handleEditPractitioner,
  playClickSound,
  defaults,
  DAYS,
  getShiftStyles,
}) {
  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold border-b pb-2">Practitioners</h2>
      {dataLoading ? (
        <div className="space-y-4 animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-28" />
          <div className="h-11 bg-gray-200 rounded-xl" />
          <div className="mt-4 p-4 border-2 border-gray-200 rounded-xl space-y-4">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 bg-gray-200 rounded-full" />
              <div className="flex-1 space-y-2">
                <div className="h-5 bg-gray-200 rounded w-32" />
                <div className="h-4 bg-gray-100 rounded w-24" />
              </div>
            </div>
            <div className="h-4 bg-gray-100 rounded" />
            <div className="h-4 bg-gray-100 rounded w-5/6" />
            <div className="h-4 bg-gray-100 rounded w-4/6" />
          </div>
        </div>
      ) : (<>
      <p className="text-base font-medium mb-2">Practitioner:</p>
      <select className="w-full p-3 border rounded-xl bg-white shadow-sm" value={selectedPractitioner?.name || ''} onChange={e => { playClickSound(); const prac = activePractitioners.find(p => p.name === e.target.value); setSelectedPractitioner(prac); setActivePracTab('bio'); }}>
        <option value="" className="text-gray-500">Select Practitioner</option>
        {activePractitioners.filter(prac => { if (!selectedCategory) return true; const cat = getSpecialtyCategory(specialties, prac.specialty); if (cat) return cat === selectedCategory; /* a known specialty with no category shows under every category; unknown/blank stays hidden */ return !!prac.specialty && (specialties || []).some(sp => sp.name === prac.specialty); }).sort((a, b) => a.name.localeCompare(b.name)).map((prac, i) => (<option key={i} value={prac.name}>{prac.name}</option>))}
      </select>

      {selectedPractitioner && (
        <PractitionerCard
          selectedPractitioner={selectedPractitioner}
          activeServices={activeServices}
          categories={categories}
          specialties={specialties}
          primaryOfferedServices={primaryOfferedServices}
          addonOfferedServices={addonOfferedServices}
          activePracTab={activePracTab}
          setActivePracTab={setActivePracTab}
          setSelectedCategory={setSelectedCategory}
          setSelectedService={setSelectedService}
          setMainBgColor={setMainBgColor}
          adminMode={adminMode}
          handleEditPractitioner={handleEditPractitioner}
          playClickSound={playClickSound}
          defaults={defaults}
          DAYS={DAYS}
          getShiftStyles={getShiftStyles}
        />
      )}
      </>)}
    </div>
  );
}
